import { render, staticRenderFns } from "./SellersList.vue?vue&type=template&id=f2834c60&scoped=true&"
import script from "./SellersList.vue?vue&type=script&lang=js&"
export * from "./SellersList.vue?vue&type=script&lang=js&"
import style0 from "./SellersList.vue?vue&type=style&index=0&id=f2834c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2834c60",
  null
  
)

export default component.exports